import { isCustomizedType, reduce } from "et3-type-guards";

import i18nServerResponse from "../../constants/i18n-server-response";
import { TCorePage } from "../../Types";
import { post } from "../axios-post";

export const apiCallWarnUser = async ({
  userUUID,
  TBW_ids,
  pageName
}: {
  userUUID: string;
  TBW_ids: number[];
  pageName: TCorePage;
}) => {
  const { status, data, et3Error } = await post("user/warnUser", {
    userUUID,
    pageName,
    TBW_ids
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: "OK",
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: "ERROR",
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: "ERROR",
      status: "ERROR",
      code: "ERROR"
    };
  }
};
